import React, { useEffect, useRef, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import TermsAndConditions from "./TermsAndConditions";
// import { useSelector } from "react-redux";
import {
  GET_RFQbyID,
  PATCH_VendorDashboardData,
} from "../../slices/Dashboards/VendorDashboard/thunk";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Label,
  Input,
  Alert,
} from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import CPBreadCrumbMasters from "../../Components/CPComponents/CPLayouts/CPBreadCrumbMasters";
import InfoButtonWithTooltip from "../../Components/CPComponents/CPIcons/InfoToolTip";
import { GET_Unit_Data } from "../../slices/thunks";
import { updateStatus } from "../../slices/Dashboards/VendorDashboard/reducer";

import SuccessModal from "./SuccessModal";
import { GET_VendorDashboard } from "../../slices/Dashboards/VendorDashboard/thunk";
import { useSelector } from "react-redux";
import { log } from "three/src/utils.js";

// New Confirmation Modal Component
const ConfirmationModal = ({ isOpen, toggle, onConfirm, message, title }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{title || "Confirm Action"}</ModalHeader>
      <ModalBody>
        <p className="mb-4">{message}</p>
        <div className="d-flex justify-content-end gap-2">
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => {
              onConfirm();
              toggle();
            }}
          >
            Confirm
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

// New Alert Modal Component
const AlertModal = ({ isOpen, toggle, message, type = "danger" }) => {
  const getIcon = () => {
    switch (type) {
      case "success":
        return <i className="ri-checkbox-circle-line text-success fs-1"></i>;
      case "warning":
        return <i className="ri-error-warning-line text-warning fs-1"></i>;
      default:
        return <i className="ri-error-warning-line text-danger fs-1"></i>;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalBody className="text-center p-4">
        {getIcon()}
        <p className="mt-3 mb-4">{message}</p>
        <Button color={type} onClick={toggle}>
          OK
        </Button>
      </ModalBody>
    </Modal>
  );
};

const OrderDetails = () => {
  const [searchParams] = useSearchParams();
  const VoucherID = searchParams.get("VoucherID");
  const Regret = searchParams.get("Regret");

  // New state for modals
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    message: "",
    title: "",
    onConfirm: null,
  });

  const [alertModal, setAlertModal] = useState({
    isOpen: false,
    message: "",
    type: "danger",
  });

  const updatedVendorDashboard = () => {
    dispatch(GET_RFQbyID(VoucherID));
  };

  const patchsuccess = useSelector(
    (state) => state.VendorDashboard.patchDataSuccess,
  );
  const patcherror = useSelector(
    (state) => state.VendorDashboard.patchDataError,
  );

  const dispatch = useDispatch();

  const data = useSelector((state) => state.VendorDashboard.rfqData);

  const loading = useSelector((state) => state.VendorDashboard.rfqLoading);
  const error = useSelector((state) => state.VendorDashboard.rfqError);
  const success = useSelector((state) => state.VendorDashboard.rfqSuccess);

  const Unitdata = useSelector((state) => state.UnitData.data);
  const Unitloading = useSelector((state) => state.UnitData.loading);
  const Uniterror = useSelector((state) => state.UnitData.error);
  const Unitsuccess = useSelector((state) => state.UnitData.success);

  const [order, setOrder] = useState(data);

  const [modal, setModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [availability, setAvailability] = useState(() => {
    const isRegret = searchParams.get("Regret") === "true";
    return isRegret ? "regret" : "available";
  });

  const [freight, setFreight] = useState(order?.VendorAdditionalFreightAmount);
  const [freightGst, setFreightGst] = useState(
    order?.VendorAdditionalFreightGst,
  );
  const [insurance, setInsurance] = useState(
    order?.VendorAdditionalInsuranceAmount,
  );
  const [insuranceGst, setInsuranceGst] = useState(
    order?.VendorAdditionalInsuranceGst,
  );
  const [otherCharges, setOtherCharges] = useState(
    order?.VendorAdditionalOtherChargesAmount,
  );
  const [otherChargesGst, setOtherChargesGst] = useState(
    order?.VendorAdditionalOtherChargesGst,
  );

  const calculateGSTTotal = () => {
    if (!order?.ItemDetails || order?.ItemDetails.length === 0) return 0;
    const totalGST = order?.ItemDetails?.reduce((acc, item) => {
      const taxRate = parseFloat(item.TaxRate) || 0;
      const amount = parseFloat(item.Amount) || 0;
      return acc + (amount * taxRate) / 100;
    }, 0);
    return parseFloat(totalGST.toFixed(2));
  };

  const [gst, setGst] = useState(calculateGSTTotal);
  const [discount, setDiscount] = useState(0);
  const [vendorDiscount, setVendorDiscount] = useState(
    order?.VendorAdditionalDiscountAmount,
  );
  const [vendorDiscountGst, setVendorDiscountGst] = useState(
    order?.VendorAdditionalDiscountGst,
  );
  const today = new Date().toISOString()?.split("T")[0];
  const [vendorNo, setVendorNo] = useState(
    (order?.VendorVoucherNumber ?? "").toString(),
  );
  const [vendorDate, setVendorDate] = useState(today);
  const [errorMessage, setErrorMessage] = useState("");

  const hasAutoSaved = useRef(false);

useEffect(() => {
  if (
    Regret === "true" &&
    order &&
    order?.ItemDetails?.length > 0 &&
    !hasAutoSaved.current
  ) {
    hasAutoSaved.current = true;

    // Call save automatically
    handleSaveButton();
  }
}, [order, Regret]);


  useEffect(() => {
    setVendorNo((order?.VendorVoucherNumber ?? "").toString());
    setVendorDate(
      order?.VendorVoucherDate === "0001-01-01T00:00:00"
        ? today
        : order?.VendorVoucherDate,
    );
  }, [order]);

  useEffect(() => {
    dispatch(GET_Unit_Data());
  }, [dispatch]);

  useEffect(() => {
    if (order?.ItemDetails) {
      const calculatedGST = calculateGSTTotal();
      setGst(calculatedGST);
    }
  }, [order]);

  useEffect(() => {
    if (Unitsuccess) {
    }
    if (Uniterror) {
    }
  }, [Unitsuccess, dispatch, Uniterror]);

  useEffect(() => {
    dispatch(GET_RFQbyID(VoucherID));
    if (patchsuccess) {
      dispatch(GET_RFQbyID(VoucherID));
      setModalOpen(true);
      setTimeout(() => setModalOpen(false), 2000);
    }
  }, [dispatch, VoucherID, patchsuccess]);

  const hasAppliedRegret = useRef(false);

  useEffect(() => {
    if (!loading && success && data?.length > 0) {
      const orderCopy = { ...data[0] };
      if (Regret === "true" && !hasAppliedRegret.current) {
        orderCopy.ItemDetails = orderCopy.ItemDetails.map((item) => ({
          ...item,
          Regret: true,
          VendorQuantity: 0,
          Rate: 0,
          Amount: 0,
          HSNSAC: "0",
          VendorUnit: "",
          VendorMake: "",
          Discount: 0,
          Description: item.AskDescription || "",
        }));
        orderCopy.VendorAdditionalFreightAmount = 0;
        orderCopy.VendorAdditionalFreightGst = 0;
        orderCopy.VendorAdditionalInsuranceAmount = 0;
        orderCopy.VendorAdditionalInsuranceGst = 0;
        orderCopy.VendorAdditionalOtherChargesAmount = 0;
        orderCopy.VendorAdditionalOtherChargesGst = 0;
        orderCopy.VendorAdditionalDiscountAmount = 0;
        orderCopy.VendorAdditionalDiscountGst = 0;

        setFreight(0);
        setFreightGst(0);
        setInsurance(0);
        setInsuranceGst(0);
        setOtherCharges(0);
        setOtherChargesGst(0);
        setVendorDiscount(0);
        setVendorDiscountGst(0);

        hasAppliedRegret.current = true;
      }

      setOrder(orderCopy);
      setVendorNo((orderCopy?.VendorVoucherNumber ?? "").toString());
      setVendorDate(
        order?.VendorVoucherDate === "0001-01-01T00:00:00"
          ? today
          : order?.VendorVoucherDate,
      );
      setVendorDiscount(orderCopy?.VendorAdditionalDiscountAmount);
      setFreight(orderCopy?.VendorAdditionalFreightAmount);
      setFreightGst(orderCopy?.VendorAdditionalFreightGst);
      setVendorDiscountGst(orderCopy?.VendorAdditionalDiscountGst);
      setInsurance(orderCopy?.VendorAdditionalInsuranceAmount);
      setInsuranceGst(orderCopy?.VendorAdditionalInsuranceGst);
      setOtherChargesGst(orderCopy?.VendorAdditionalOtherChargesGst);
      setOtherCharges(orderCopy?.VendorAdditionalOtherChargesAmount);
    }
  }, [loading, success, data, Regret]);

  const validationSchemaIfPending =
    availability === "available"
      ? Yup.object({
          quantity: Yup.number()
            .min(0, "Quantity must be 0 or greater")
            .required("Quantity is required")
            .max(
              selectedItem ? selectedItem.AskQuantity : 0,
              "Quantity must be less than or equal to required quantity",
            ),
          rate: Yup.number()
            .min(0, "Rate must be 0 or greater")
            .required("Rate is required"),
          discount: Yup.number().min(0, "Discount cannot be negative"),
          hsn: Yup.number()
            .integer("HSN must be a whole number")
            .required("HSN is required"),
          unit: Yup.string().required("Unit is required"),
        })
      : Yup.object({
          quantity: 0,
          rate: 0,
          discount: 0,
          hsn: 0,
          unit: "",
          make: "",
        });

  const validationSchemaIfNotPending =
    availability === "available"
      ? Yup.object({
          quantity: Yup.number().min(0, "Quantity must be 0 or greater"),
          rate: Yup.number().min(0, "Rate must be 0 or greater"),
          discount: Yup.number().min(0, "Discount cannot be negative"),
          hsn: Yup.number().integer("HSN must be a whole number"),
          unit: Yup.string().required("Unit is required"),
        })
      : Yup.object({
          quantity: 0,
          rate: 0,
          discount: 0,
          hsn: 0,
          unit: "",
          make: "",
        });

  const calculateAmount = (quantity, rate, discount, tax) => {
    const totalAmount = quantity * rate;
    const discountAmount = (totalAmount * discount) / 100;
    const discountedAmount =
      totalAmount - discountAmount > 0 ? totalAmount - discountAmount : 0;
    const taxAmount = (discountedAmount * tax) / 100;
    const finalAmount = Math.max(discountedAmount, 0);

    return {
      finalAmount: parseFloat(finalAmount.toFixed(2)),
      taxAmount: parseFloat(taxAmount.toFixed(2)),
    };
  };

  useEffect(() => {
    setGst(calculateGSTTotal);
    calculateTotal;
  }, [loading, data, success]);

  const calculateSubTotal = () => {
    return parseFloat(
      order?.ItemDetails?.reduce(
        (total, item) => total + (item?.Amount || 0),
        0,
      ).toFixed(2),
    );
  };

  const calculateTotal = () => {
    let subtotal = parseFloat(
      order?.ItemDetails?.reduce(
        (total, item) => total + (item?.Amount || 0),
        0,
      ),
    ).toFixed(2);
    const freightValue = parseFloat(freight) || 0;
    const discountValue = parseFloat(discount) || 0;
    const gstValue = parseFloat(gst) || 0;

    const discountAmount = (subtotal * discountValue) / 100;
    subtotal -= discountAmount;

    subtotal += gstValue;
    subtotal += freightValue + (freightValue * freightGst) / 100;
    subtotal -= vendorDiscount + (vendorDiscount * vendorDiscountGst) / 100;
    subtotal += insurance + (insuranceGst * insurance) / 100;
    subtotal += otherCharges + (otherChargesGst * otherCharges) / 100;

    return parseFloat(subtotal.toFixed(2));
  };

  const handleSave = (values) => {
    const updatedItems = [...order.ItemDetails];
    const newAmount =
      availability === "regret"
        ? 0
        : calculateAmount(
            values.quantity,
            values.rate,
            values.discount,
            values.tax,
          ).finalAmount;

    updatedItems[selectedIndex] = {
      ...selectedItem,
      Regret: availability === "regret" ? true : false,
      VendorQuantity: availability === "regret" ? 0 : values.quantity,
      Rate: availability === "regret" ? 0 : values.rate,
      Amount: newAmount,
      Description: values.description,
      TaxRate: values.tax,
      HSNSAC: availability === "regret" ? "0" : values.hsn,
      Discount: availability === "regret" ? 0 : values.discount,
      VendorUnit: availability === "regret" ? "" : values.unit,
      VendorMake: availability === "regret" ? "" : values.make,
    };
    setOrder({ ...order, ItemDetails: updatedItems });

    if (availability === "regret" && order?.ItemDetails.length < 2) {
      setOtherCharges(0);
      setInsurance(0);
      setFreight(0);
      setVendorDiscount(0);
    }

    toggleModal();
  };

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "saved":
        return "badge bg-success-subtle text-success";
      case "expired":
        return "badge bg-danger-subtle text-danger";
      case "lost":
        return "badge bg-light-subtle text-muted";
      default:
        return "badge bg-warning-subtle text-warning";
    }
  };

  const toggleModal = () => setModal(!modal);

  //data for terms and conditions
  const [termsData, setTermsData] = useState({
    vendorInputs: {},
    checkboxes: {},
  });

  const handleDataChange = (updatedTermDetails) => {
    setOrder((prevData) => ({
      ...prevData,
      TermDetails: updatedTermDetails,
    }));
  };  

  const handleRegretAll = () => {
    if (!order) return;

    // Use confirmation modal instead of window.confirm
    setConfirmModal({
      isOpen: true,
      title: "Confirm Regret All",
      message:
        "Are you sure you want to mark all items as Regret? This will clear all entered values and cannot be undone.",
      onConfirm: () => {
        const updatedOrder = JSON.parse(JSON.stringify(order));

        updatedOrder.ItemDetails = updatedOrder.ItemDetails.map((item) => ({
          ...item,
          Regret: true,
          VendorQuantity: 0,
          Rate: 0,
          Amount: 0,
          HSNSAC: "0",
          VendorUnit: "",
          VendorMake: "",
          Discount: 0,
          Description: item.AskDescription || "",
        }));

        updatedOrder.VendorAdditionalFreightAmount = 0;
        updatedOrder.VendorAdditionalFreightGst = 0;
        updatedOrder.VendorAdditionalInsuranceAmount = 0;
        updatedOrder.VendorAdditionalInsuranceGst = 0;
        updatedOrder.VendorAdditionalOtherChargesAmount = 0;
        updatedOrder.VendorAdditionalOtherChargesGst = 0;
        updatedOrder.VendorAdditionalDiscountAmount = 0;
        updatedOrder.VendorAdditionalDiscountGst = 0;

        setOrder(updatedOrder);
        setFreight(0);
        setFreightGst(0);
        setInsurance(0);
        setInsuranceGst(0);
        setOtherCharges(0);
        setOtherChargesGst(0);
        setVendorDiscount(0);
        setVendorDiscountGst(0);
      },
    });
  };

  const handleSaveButton = async () => {
    try {
      updateStatus();

      // Validate item details
      const invalidItems = order?.ItemDetails?.filter(
        (item) =>
          (item.Amount === 0 || item.Amount === "") &&
          (item.Regret === false || item.Regret === ""),
      );

      if (invalidItems?.length > 0) {
        setAlertModal({
          isOpen: true,
          message: "Please mark as regret or fill the details for all items.",
          type: "danger",
        });
        return;
      }

      // Check if any item is still available
      const hasAvailableItems = order?.ItemDetails?.some(
        (item) => item?.Regret === false,
      );

      // Validate terms only if available items exist
      if (order?.TermDetails && hasAvailableItems) {
        const invalidTerms = order?.TermDetails?.some(
          (term) =>
            term?.Checkbox === undefined || term?.VendorTerms === undefined,
        );

        if (invalidTerms) {
          setAlertModal({
            isOpen: true,
            message: "Please go through all the terms and conditions.",
            type: "danger",
          });
          return;
        }
      }

      setErrorMessage("");

      if (
        order?.Status?.toLowerCase() === "pending" ||
        order?.Status?.toLowerCase() === "saved"
      ) {
        const allItemsRegret =
          order?.ItemDetails?.length > 0 &&
          order?.ItemDetails?.every((item) => item?.Regret === true);

        // ✅ JSX message with icon
        const confirmMessage = allItemsRegret ? (
          <div className="d-flex align-items-center gap-2 fw-semibold">
            <i className="ri-close-circle-fill fs-4 text-danger"></i>
            Do you want to <span className="text-danger">Regret</span> this
            quotation?
          </div>
        ) : (
          <div className="d-flex align-items-center gap-2 fw-semibold">
            <i className="ri-save-line fs-4 text-success"></i>
            Do you want to save this quotation?
          </div>
        );

        setConfirmModal({
          isOpen: true,
          title: allItemsRegret ? "Confirm Regret" : "Confirm Save",
          message: confirmMessage,
          onConfirm: async () => {
            // Prepare Summary
            const summary = {
              TotalAmount: calculateTotal(),
              Gst: gst,
              Freight: freight,
              VendorDiscount: vendorDiscount,
              SubTotal: calculateSubTotal(),
            };

            order.VendorVoucherNumber = vendorNo;
            order.VendorAdditionalDiscountAmount = vendorDiscount;
            order.VendorAdditionalFreightAmount = freight;
            order.VendorAdditionalDiscountGst = vendorDiscountGst;
            order.VendorAdditionalFreightGst = freightGst;
            order.VendorAdditionalInsuranceAmount = insurance;
            order.VendorAdditionalInsuranceGst = insuranceGst;
            order.VendorAdditionalOtherChargesAmount = otherCharges;
            order.VendorAdditionalOtherChargesGst = otherChargesGst;

            if (vendorDate === "0001-01-01T00:00:00") {
              setAlertModal({
                isOpen: true,
                message: "Fill Due Date",
                type: "warning",
              });
              return;
            }

            try {
              await dispatch(PATCH_VendorDashboardData(order));

              if (patchsuccess) {
                updatedVendorDashboard();
              }

              setModalOpen(true);
              setTimeout(() => setModalOpen(false), 2000);
            } catch (error) {
              console.log("Error while API calling", error);
              setAlertModal({
                isOpen: true,
                message: "Error while saving. Please try again.",
                type: "danger",
              });
            }

            updateStatus();
          },
        });
      }
    } catch (error) {
      console.log("Unexpected error:", error);
      setAlertModal({
        isOpen: true,
        message: "An unexpected error occurred.",
        type: "danger",
      });
    }
  };

  const formatIndianAmount = (amount) => {
    const num = parseFloat(amount || 0).toFixed(2);
    const [whole, decimal] = num?.split(".");
    const lastThree = whole.substring(whole.length - 3);
    const otherNumbers = whole.substring(0, whole.length - 3);
    const withCommas = otherNumbers
      ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree
      : lastThree;
    return `₹${withCommas}.${decimal}`;
  };

  const plantDetails = order
    ? {
        Name: order.ClientName,
        Code: order.ClientCode,
        ClientEmail: order.ClientEmail,
        ClientNumber: order.ClientNumber,
        GSTIN: order.ClientGSTIN,
        ClientContactEmail: order.ClientContactEmail,
        Number: order.ClientContactMobile,
        VoucherDate: new Date(order.ClientVoucherDate).toLocaleDateString(),
        VoucherNumber: order.ClientVoucherNumber,
        ContactPerson: order.ClientContactPerson,
        Designation: order.ClientDesignation,
        OfficeHours: order.ClientOfficeHours,
      }
    : null;

  const vendorDetails = order
    ? {
        VendorName: order.VendorName,
        VendorGSTIN: order.VendorGSTIN,
        VendorAddress: order.VendorAddress,
        VendorEmail: order.VendorEmail,
        VendorMobile: order.VendorMobile,
      }
    : null;

  return (
    <div className="mt-5">
      <Container fluid>
        <CPBreadCrumbMasters
          title={order?.ClientName}
          pageTitle={order?.ClientVoucherNumber}
          data={plantDetails}
        />

        {/* Confirmation Modal */}
        <ConfirmationModal
          isOpen={confirmModal.isOpen}
          toggle={() => setConfirmModal({ ...confirmModal, isOpen: false })}
          onConfirm={confirmModal.onConfirm}
          message={confirmModal.message}
          title={confirmModal.title}
        />

        {/* Alert Modal */}
        <AlertModal
          isOpen={alertModal.isOpen}
          toggle={() => setAlertModal({ ...alertModal, isOpen: false })}
          message={alertModal.message}
          type={alertModal.type}
        />

        <Col>
          <Card>
            <CardHeader className="p-4">
              {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

              {/* Top Section */}
              <Row className="align-items-center mb-3">
                <Col className="d-flex align-items-center">
                  <h5 className="mb-0 cursor-pointer">
                    <InfoButtonWithTooltip
                      data={vendorDetails}
                      id="toolTipOrderDetails"
                    />
                    {order?.VendorName}
                  </h5>
                </Col>

                <Col className="text-end d-flex flex-column align-items-end gap-1">
                  <Button color="primary" size="md" onClick={handleSaveButton}>
                    Save
                  </Button>

                  <div className="text-muted mb-0">
                    <span className={getStatusClass(order?.Status)}>
                      {order?.Status}
                    </span>
                  </div>
                </Col>
              </Row>

              {/* Form Row */}
              <Row className="align-items-end g-3">
                <Col md={6} lg={4}>
                  <Label className="fw-semibold text-dark mb-1">
                    Quotation Number:
                  </Label>
                  <Input
                    type="text"
                    value={vendorNo}
                    onChange={(e) => setVendorNo(e.target.value || "")}
                    placeholder="Enter Voucher No."
                    style={{
                      borderRadius: "8px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      height: "38px",
                    }}
                  />
                </Col>

                <Col md={6} lg={4}>
                  <Label className="fw-semibold text-dark mb-1">
                    Quotation Date:
                  </Label>
                  <Input
                    type="date"
                    value={vendorDate?.split("T")[0]}
                    onChange={(e) => setVendorDate(e.target.value)}
                    style={{
                      borderRadius: "8px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      height: "38px",
                    }}
                  />
                </Col>

                <Col md={6} lg={4}>
                  <Label className="fw-semibold text-dark mb-1 invisible">
                    Action
                  </Label>
                  <Button
                    color="danger"
                    onClick={handleRegretAll}
                    style={{
                      borderRadius: "8px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      height: "38px",
                    }}
                  >
                    Regret All
                  </Button>
                </Col>
              </Row>
            </CardHeader>

            <CardBody>
              <div className="table-responsive table-card">
                <table className="table table-borderless align-middle mb-0 table-sm">
                  <thead className="table-light text-muted">
                    <tr>
                      <th colSpan="2" scope="col">
                        Particulars
                      </th>
                      <th scope="col" className="text-end">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {order?.ItemDetails?.map((item, index) => (
                      <tr key={index}>
                        <td
                          colSpan="2"
                          onClick={() => {
                            setSelectedItem(item);
                            setSelectedIndex(index);
                            setAvailability(
                              item.Regret ? "regret" : "available",
                            );
                            toggleModal();
                          }}
                          className="ps-3 ps-md-4 align-top"
                          style={{ cursor: "pointer" }}
                        >
                          <div className="d-flex flex-column gap-1">
                            <h5 className="fs-6 text-truncate mb-0">
                              {`${item?.ItemName} - ${item?.AskQuantity} ${
                                item.VendorUnit
                                  ? item.VendorUnit
                                  : item?.UnitName
                              }`}
                            </h5>

                            {item.Amount ? (
                              <small className="text-muted">
                                {formatIndianAmount(item.Rate)} ×{" "}
                                {item.VendorQuantity} {item.vendorUnit} |
                                Discount: {item.Discount}%
                              </small>
                            ) : item.Regret ? (
                              <small className="text-danger">Regret</small>
                            ) : (
                              <small className="text-warning">
                                Not filled yet
                              </small>
                            )}

                            <div className="d-flex flex-column flex-md-row gap-1 gap-md-3">
                              {item?.VendorMake && (
                                <small className="text-muted text-truncate">
                                  Make: {item.VendorMake}
                                </small>
                              )}
                              {item?.Description && (
                                <small className="text-muted text-truncate">
                                  Description: {item.Description}
                                </small>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className="text-end pe-3 pe-md-4 align-top">
                          <span className="fs-6">
                            {formatIndianAmount(
                              parseFloat((item.Amount || 0).toFixed(2)),
                            )}
                          </span>
                        </td>
                      </tr>
                    ))}
                    <tr className="table-active">
                      <th colSpan="2">Sub Total:</th>
                      <td className="text-end">
                        <span className="fw-semibold">
                          {formatIndianAmount(calculateSubTotal())}
                        </span>
                      </td>
                    </tr>
                    <tr className="table-active">
                      <th colSpan="2">Discount</th>
                      <td className="text-end d-flex align-items-center justify-content-end gap-2">
                        {"(-)"}
                        <div className="input-group" style={{ width: "110px" }}>
                          <span className="input-group-text">₹</span>
                          <Input
                            type="text"
                            pattern="\d*"
                            value={
                              vendorDiscount > 0
                                ? vendorDiscount
                                    .toString()
                                    .replace(/^0+(?!$)/, "")
                                : ""
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setVendorDiscount(
                                  value === "" ? 0 : parseFloat(value),
                                );
                              }
                            }}
                            className="form-control form-control-sm text-end"
                          />
                        </div>
                      </td>
                    </tr>

                    <tr className="table-active">
                      <th colSpan="2">
                        Freight{" "}
                        <span style={{ fontSize: "0.8em", color: "#6c757d" }}>
                          (excl. GST)
                        </span>
                      </th>
                      <td className="text-end d-flex align-items-center justify-content-end gap-2">
                        <select
                          value={freightGst}
                          onChange={(e) =>
                            setFreightGst(parseFloat(e.target.value) || 0)
                          }
                          className="form-select form-select-sm"
                          style={{ width: "70px" }}
                        >
                          <option value="0">0%</option>
                          <option value="5">5%</option>
                          <option value="12">12%</option>
                          <option value="18">18%</option>
                          <option value="28">28%</option>
                        </select>

                        <div className="input-group" style={{ width: "110px" }}>
                          <span className="input-group-text">₹</span>
                          <Input
                            type="text"
                            pattern="\d*"
                            value={
                              freight > 0
                                ? freight.toString().replace(/^0+(?!$)/, "")
                                : ""
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setFreight(
                                  value === "" ? 0 : parseFloat(value),
                                );
                              }
                            }}
                            className="form-control form-control-sm text-end"
                          />
                        </div>
                      </td>
                    </tr>

                    <tr className="table-active">
                      <th colSpan="2">
                        Insurance{" "}
                        <span style={{ fontSize: "0.8em", color: "#6c757d" }}>
                          (excl. GST)
                        </span>
                      </th>
                      <td className="text-end d-flex align-items-center justify-content-end gap-2">
                        <select
                          value={insuranceGst}
                          onChange={(e) =>
                            setInsuranceGst(parseFloat(e.target.value) || 0)
                          }
                          className="form-select form-select-sm"
                          style={{ width: "70px" }}
                        >
                          <option value="0">0%</option>
                          <option value="5">5%</option>
                          <option value="12">12%</option>
                          <option value="18">18%</option>
                          <option value="28">28%</option>
                        </select>

                        <div className="input-group" style={{ width: "110px" }}>
                          <span className="input-group-text">₹</span>
                          <Input
                            type="text"
                            pattern="\d*"
                            value={
                              insurance > 0
                                ? insurance.toString().replace(/^0+(?!$)/, "")
                                : ""
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setInsurance(
                                  value === "" ? 0 : parseFloat(value),
                                );
                              }
                            }}
                            className="form-control form-control-sm text-end"
                          />
                        </div>
                      </td>
                    </tr>

                    <tr className="table-active">
                      <th colSpan="2">
                        Other Charges{" "}
                        <span style={{ fontSize: "0.8em", color: "#6c757d" }}>
                          (excl. GST)
                        </span>
                      </th>
                      <td className="text-end d-flex align-items-center justify-content-end gap-2">
                        <select
                          value={otherChargesGst}
                          onChange={(e) =>
                            setOtherChargesGst(parseFloat(e.target.value) || 0)
                          }
                          className="form-select form-select-sm"
                          style={{ width: "70px" }}
                        >
                          <option value="0">0%</option>
                          <option value="5">5%</option>
                          <option value="12">12%</option>
                          <option value="18">18%</option>
                          <option value="28">28%</option>
                        </select>

                        <div className="input-group" style={{ width: "110px" }}>
                          <span className="input-group-text">₹</span>
                          <Input
                            type="text"
                            pattern="\d*"
                            value={
                              otherCharges > 0
                                ? otherCharges
                                    .toString()
                                    .replace(/^0+(?!$)/, "")
                                : ""
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setOtherCharges(
                                  value === "" ? 0 : parseFloat(value),
                                );
                              }
                            }}
                            className="form-control form-control-sm text-end"
                          />
                        </div>
                      </td>
                    </tr>

                    <tr className="table-active">
                      <th colSpan="2">GST</th>
                      <td className="text-end">
                        <span className="fw-semibold">
                          {formatIndianAmount(gst)}
                        </span>
                      </td>
                    </tr>
                    <tr className="table-active">
                      <th colSpan="2">Total</th>
                      <td className="text-end">
                        <span className="fw-semibold">
                          {formatIndianAmount(calculateTotal())}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col>
          <TermsAndConditions
            onDataChange={handleDataChange}
            data={data && data[0]?.TermDetails}
          />
        </Col>

        <Col>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "10px",
            }}
          >
            <div className="text-center mt-5">
              <SuccessModal
                isOpen={modalOpen}
                toggle={() => setModalOpen(false)}
                isSuccess={patchsuccess}
                error={patcherror}
              />
            </div>
          </div>
        </Col>
      </Container>

      {selectedItem && (
        <Modal isOpen={modal} toggle={toggleModal}>
          <ModalHeader
            toggle={null}
            className="p-0 d-block "
            style={{ width: "100%" }}
          >
            <div className="bg-light p-4 rounded" style={{ width: "100%" }}>
              <div
                style={{
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  padding: "10px",
                  backgroundColor: "#f8f9fa",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <h5 style={{ margin: 0 }}>{selectedItem.ItemName}</h5>
                  <button
                    className="btn-link p-0 border-0 bg-transparent"
                    onClick={toggleModal}
                    style={{
                      fontSize: "20px",
                      color: "#6c757d",
                      cursor: "pointer",
                    }}
                  >
                    <i className="ri-close-line"></i>
                  </button>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    marginBottom: "10px",
                  }}
                >
                  Make: {selectedItem.AskMakeName} ({selectedItem.AskMakeCode})
                  | Quantity: {selectedItem.AskQuantity} Pcs
                </div>
                <div style={{ fontSize: "12px", color: "#6c757d" }}>
                  {selectedItem.AskDescription}
                </div>
              </div>
            </div>
          </ModalHeader>

          <ModalBody>
            <div
              style={{
                border: "1px solid #dee2e6",
                borderRadius: "5px",
                padding: "10px",
                backgroundColor: "#f8f9fa",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#198754",
                    marginRight: "10px",
                  }}
                >
                  Status:
                </span>
                <div className="d-flex">
                  <div className="form-check me-3">
                    <Input
                      type="radio"
                      name="availability"
                      value="available"
                      id="available"
                      checked={availability === "available"}
                      onChange={(e) => setAvailability(e.target.value)}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="available">
                      Available
                    </label>
                  </div>
                  <div className="form-check">
                    <Input
                      type="radio"
                      name="availability"
                      value="regret"
                      id="regret"
                      checked={availability === "regret"}
                      onChange={(e) => setAvailability(e.target.value)}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="regret">
                      Regret
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <Formik
              initialValues={{
                quantity:
                  selectedItem.VendorQuantity || selectedItem.AskQuantity,
                rate: selectedItem.Rate || "",
                discount: selectedItem.Discount || 0.0,
                description: selectedItem.Description || "",
                tax: selectedItem.TaxRate || 0.0,
                hsn: selectedItem.HSNSAC || "",
                unit: selectedItem.VendorUnit || selectedItem.UnitName,
                make: selectedItem.VendorMake || "",
                amount: calculateAmount(
                  selectedItem.VendorQuantity || 0,
                  selectedItem.Rate || 0,
                  selectedItem.Discount || 0,
                ).finalAmount,
              }}
              validationSchema={
                order?.Status != "Pending"
                  ? validationSchemaIfNotPending
                  : validationSchemaIfPending
              }
              onSubmit={handleSave}
            >
              {({ values, errors, touched, handleChange, setFieldValue }) => (
                <Form>
                  <Row>
                    <Col>
                      <Label for="quantity">Quantity</Label>
                      <Input
                        type="number"
                        name="quantity"
                        id="quantity"
                        value={values.quantity}
                        min="0"
                        onChange={(e) => {
                          handleChange(e);
                          const { taxAmount: taxAmount1 } = calculateAmount(
                            values.quantity,
                            values.rate,
                            values.discount,
                            values.tax,
                          );
                          const { finalAmount, taxAmount: taxAmount2 } =
                            calculateAmount(
                              e.target.value,
                              values.rate,
                              values.discount,
                              values.tax,
                            );
                          setGst(
                            (prevGst) =>
                              parseFloat(prevGst) + taxAmount2 - taxAmount1,
                          );
                          setFieldValue("amount", finalAmount);
                        }}
                        disabled={availability === "regret"}
                      />
                      <div className="text-danger">
                        {touched.quantity && errors.quantity}
                      </div>
                    </Col>
                    <Col>
                      <Label for="rate">Basic Rate</Label>
                      <Input
                        type="number"
                        name="rate"
                        id="rate"
                        value={values.rate}
                        onChange={(e) => {
                          handleChange(e);
                          const { taxAmount: taxAmount1 } = calculateAmount(
                            values.quantity,
                            values.rate,
                            values.discount,
                            values.tax,
                          );
                          const { finalAmount, taxAmount: taxAmount2 } =
                            calculateAmount(
                              values.quantity,
                              e.target.value,
                              values.discount,
                              values.tax,
                            );
                          setGst(
                            (prevGst) =>
                              parseFloat(prevGst) + taxAmount2 - taxAmount1,
                          );
                          setFieldValue("amount", finalAmount);
                        }}
                        disabled={availability === "regret"}
                      />
                      <div className="text-danger">
                        {touched.rate && errors.rate}
                      </div>
                    </Col>

                    <Col>
                      <Label for="unit">Unit</Label>
                      <Input
                        type="select"
                        name="unit"
                        id="unit"
                        value={values.unit}
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue("unit", e.target.value);
                        }}
                        disabled={availability === "regret"}
                      >
                        {values.unit && (
                          <option key="initial" value={values.unit}>
                            {values.unit} →{" "}
                            {Unitdata?.find((u) => u.UnitCode === values.unit)
                              ?.UnitName || "Selected Unit"}
                          </option>
                        )}

                        {Unitdata &&
                          Unitdata.filter(
                            (unit) => unit.UnitCode !== values.unit,
                          ).map((unit) => (
                            <option key={unit.UnitCode} value={unit.UnitCode}>
                              {unit.UnitCode} → {unit.UnitName}
                            </option>
                          ))}
                      </Input>
                    </Col>

                    <Col>
                      <Label for="discount">Dis (%)</Label>
                      <Input
                        type="number"
                        name="discount"
                        id="discount"
                        value={values.discount}
                        min="0"
                        onChange={(e) => {
                          handleChange(e);
                          const { taxAmount: taxAmount1 } = calculateAmount(
                            values.quantity,
                            values.rate,
                            values.discount,
                            values.tax,
                          );
                          const { finalAmount, taxAmount: taxAmount2 } =
                            calculateAmount(
                              values.quantity,
                              values.rate,
                              e.target.value,
                              values.tax,
                            );
                          setGst(
                            (prevGst) =>
                              parseFloat(prevGst) + taxAmount2 - taxAmount1,
                          );
                          setFieldValue("amount", finalAmount);
                        }}
                        disabled={availability === "regret"}
                      />
                      <div className="text-danger">
                        {touched.discount && errors.discount}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Label for="description">Description</Label>
                      <Input
                        type="text"
                        name="description"
                        id="description"
                        value={values.description}
                        onChange={handleChange}
                        disabled={availability === "regret"}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Label for="make">Make</Label>
                      <Input
                        type="text"
                        name="make"
                        id="make"
                        value={values.make || ""}
                        onChange={handleChange}
                        disabled={availability === "regret"}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Label for="hsn">HSN Code</Label>
                      <Input
                        type="string"
                        name="hsn"
                        id="hsn"
                        value={values.hsn}
                        min="0"
                        onChange={handleChange}
                        disabled={availability === "regret"}
                      />
                      <div className="text-danger">
                        {touched.hsn && errors.hsn}
                      </div>
                    </Col>
                    <Col>
                      <Label for="tax">Tax (%)</Label>
                      <Input
                        type="select"
                        name="tax"
                        id="tax"
                        value={values.tax}
                        min="0"
                        onChange={(e) => {
                          handleChange(e);

                          const { taxAmount: taxAmount1 } = calculateAmount(
                            values.quantity,
                            values.rate,
                            values.discount,
                            values.tax,
                          );
                          const { finalAmount, taxAmount: taxAmount2 } =
                            calculateAmount(
                              values.quantity,
                              values.rate,
                              values.discount,
                              e.target.value,
                            );
                          setGst(
                            (prevGst) =>
                              parseFloat(prevGst) + taxAmount2 - taxAmount1,
                          );
                          setFieldValue("amount", finalAmount);
                          setFieldValue("tax", parseFloat(e.target.value));
                        }}
                        disabled={availability === "regret"}
                      >
                        <option value="0">0%</option>
                        <option value="5">5%</option>
                        <option value="12">12%</option>
                        <option value="18">18%</option>
                        <option value="28">28%</option>
                      </Input>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Label for="amount">Amount</Label>
                      <Input
                        type="text"
                        name="amount"
                        id="amount"
                        value={formatIndianAmount(values.amount)}
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-end">
                      <br />
                      <Button type="submit" color="primary">
                        Save
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      )}
    </div>
  );
};

export default OrderDetails;
